
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ClassboardIconComponent } from "./classboard-icon.svg";

export const ClassboardIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ClassboardIconComponent {...props} />;
};
